import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { VehicleFingerprintContext } from '../../vehicle-fingerprint.models';

@Component({
  selector: 'app-vehicle-fingerprint-daily-pattern',
  templateUrl: './daily-pattern.component.html',
  styleUrls: ['./daily-pattern.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VehicleFingerprintDailyPatternComponent implements OnChanges {
  @Input() context: VehicleFingerprintContext = { summary: null, unitId: '' };

  private readonly statuses = [
    { field: 'fDailyMovingHours', label: 'حرکت', cssClass: 'green' },
    { field: 'fDailyIdleHours', label: 'درجا', cssClass: 'cyan' },
    { field: 'fDailyParkedHours', label: 'پارک', cssClass: 'blue' },
    { field: 'fDailyInferredParkedHours', label: 'پارک استنباطی', cssClass: 'gold' },
    { field: 'fDailyUnknownHours', label: 'نامشخص', cssClass: 'purple' },
  ] as const;

  states: { label: string; cssClass: string; hours: number | null; percentage: number }[] = [];
  hasData = false;

  ngOnChanges(): void {
    this.states = this.statuses.map(status => {
      const value = this.context.summary?.[status.field];
      const hours = typeof value === 'number' && Number.isFinite(value)
        && value >= 0 && value <= 24 ? value : null;
      return { label: status.label, cssClass: status.cssClass, hours, percentage: 0 };
    });
    const total = this.states.reduce((sum, state) => sum + (state.hours ?? 0), 0);
    this.hasData = this.states.every(state => state.hours !== null) && total > 0;
    if (this.hasData) {
      this.states = this.states.map(state => ({ ...state, percentage: state.hours / total * 100 }));
    }
  }
}
